import React from "react";
import Webcam from "react-webcam";
import DetectRTC from "detectrtc";
import PropTypes from "prop-types";
import "./webcamCapture.scss";
export default class WebcamCapture extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      screenshot: null,
      havePermissions: false
    };

    this.saveAndUpload = this.saveAndUpload.bind(this);
  }

  handleCapture() {
    const screenshot = this.webcam.getScreenshot();
    this.setState({ screenshot });
  }

  handleReset() {
    this.setState({
      screenshot: null
    });
  }

  saveAndUpload() {
    let imgSrc = document.getElementById("image-capture-preview").src;
    this.props.uploadImage(imgSrc);
  }

  UNSAFE_componentWillMount() {
    DetectRTC.load(() => {
      if (DetectRTC.hasWebcam === false) {
        alert("Please install an external webcam device.");
      }
    });
  }

  render() {
    let { width = 350, height = 350, circle } = this.props;
    let webcamMainClassName = `webcam__main ${circle ? "webcam__main--circle" : ""}`;

    return (
      <div className="webcam">
        {!this.state.screenshot ? (
          <>
            <div className={webcamMainClassName}>
              <Webcam
                audio={false}
                ref={(node) => (this.webcam = node)}
                height={height}
                width={width}
                screenshotFormat="image/jpeg"
                className="profile-image-preview profile-image-live-preview"
              />
            </div>

            <div className="webcam__actions">
              <button onClick={this.handleCapture.bind(this)} className="webcam-image-capture">
                {this.props.cta}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className={webcamMainClassName}>
              <img
                style={{ width: width + "px", height: height + "px" }}
                id="image-capture-preview"
                className="profile-image-preview"
                src={this.state.screenshot}
              />
            </div>

            <div className="webcam__actions">
              <button onClick={this.saveAndUpload}>Save</button>
              <button onClick={this.handleReset.bind(this)}>Re-take</button>
            </div>
          </>
        )}
      </div>
    );
  }
}
WebcamCapture.propTypes = {
  cta: PropTypes.string,
  uploadImage: PropTypes.func.isRequired
};

WebcamCapture.defaultProps = {
  uploadImage: () => null
};
